import { render, staticRenderFns } from "./headertitle.vue?vue&type=template&id=0ba83bcf&scoped=true&"
import script from "./headertitle.vue?vue&type=script&lang=js&"
export * from "./headertitle.vue?vue&type=script&lang=js&"
import style0 from "./headertitle.vue?vue&type=style&index=0&id=0ba83bcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba83bcf",
  null
  
)

export default component.exports